module.exports = __webpack_public_path__ + "img/chord-label-C.8e999a18.png";